import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { TPermissionFormValues } from './permissions.type'
import { CurecallInput } from '@honestica/curecall-ui'
import { getValidIpList } from './permissions.util'
import { ChangeEvent, useState } from 'react'

function PermissionIpsWhitelistFields() {
  const { t } = useTranslation()
  const {
    formState: { errors, defaultValues },
    setError,
    clearErrors,
    setValue,
  } = useFormContext<TPermissionFormValues>()

  const [inputValue, setInputValue] = useState<string>(defaultValues?.ipAddressWhiteList?.join(', ') || '')

  const onChangeIpAdressWhiteList = (event: ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value)
  }

  const onBlurIpAddressWhiteList = () => {
    if (!inputValue) {
      clearErrors('ipAddressWhiteList')
      setValue('ipAddressWhiteList', [])
      return
    }

    const validIpList = getValidIpList(inputValue)
    if (!validIpList) {
      setError('ipAddressWhiteList', {
        message: t('pages.configuration.permissions.ip-white-list-format-error'),
      })
      return
    }

    clearErrors('ipAddressWhiteList')
    setValue('ipAddressWhiteList', validIpList)
  }

  return (
    <CurecallInput
      tooltipContent={t('pages.configuration.permissions.ip-white-list-instructions')}
      placeholder={t('pages.configuration.permissions.ip-white-list-placeholder')}
      label={t('pages.configuration.permissions.ip-white-list')}
      value={inputValue}
      onChange={onChangeIpAdressWhiteList}
      onBlur={onBlurIpAddressWhiteList}
      errorMessage={errors?.ipAddressWhiteList?.message}
    />
  )
}

export { PermissionIpsWhitelistFields }
